<template>
    <img class="logo" src="@/assets/img/logo/capptn-logo-s-textem-white-horizontal-65px.png">
    <div class="upper-menu">
        <UpperMenu
            v-if="env.configuration"
            @openNotifications="$emit('openNotifications')"
        />
    </div>
    <div class="main-menu">
        <ServiceMenu v-if="env.configuration"/>
    </div>
</template>

<script>
import {inject, onMounted} from "vue";
import UpperMenu from "@/components/header/UpperMenu.vue";
import ServiceMenu from "@/components/header/ServiceMenu.vue";

export default {
    name: "Header",
    emits: ['openNotifications'],
    components: {UpperMenu, ServiceMenu},
    setup(){
        const env = inject('env')

        /** @type Utilities */
        const utilities = inject('Utilities')

        onMounted(()=>{
            utilities.centerPage()
        })

        return {env}
    }


}
</script>

<style scoped>

.logo{
    position: absolute;
    left: 10px;
    top: 12px;
}

.main-menu{
    margin-top: 10px;
}
</style>
